/**
 * Dashboard (Today) widgets a new account starts with. Widgets missing from an
 * account's dashWidgets show by default, so new widgets must be listed here to start hidden.
 */
export const DEFAULT_WIDGETS = {
  // Today starts lean for new accounts; everything else can be turned on under Customize
  paycheckPlan: true,
  budget: true,
  streaks: true,
  nudge: true,
  billsDue: true,
  recap: true,
  dailyAllowance: true,
  metrics: false,
  monthly: false,
  savingsChart: false,
  spendingTrends: false,
  debtSnapshot: false,
  ytd: false,
  health: false,
  milestones: false,
  billCalendar: false,
  netWorth: false,
  affordCalc: false,
  insights: false,
  tips: false,
  cashFlow: false,
  payoffCompare: false,
  recurringCharges: false,
  momComparison: false,
  spendingStory: false,
  netWorthTrajectory: false,
  cashFlowForecast: false,
};
